﻿import {translation} from "@2d-front-monorepo/core";
import {showErrorDialog, toggleLoadingDialog} from "@2d-front-monorepo/design-library";
import {formatCurrency, PermitId, PermitResult, Permits} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {NavigateFunction} from "react-router";
import {PrivateRoutes} from "../routes";
import {getHttpClient} from "./getHttpClient";
import {ReloadEntities, reloadPermits} from "./reloadPermits";

export async function cancelPermit(permit: PermitResult, navigate: NavigateFunction): Promise<void> {
	const isActive = Permits.isActive(permit);
	let message: string;
	const args = {
		total: formatCurrency(permit.payment?.operation?.step?.total ?? permit.payment?.billing?.step?.total)
	};

	if (isActive) {
		message = translation([
			{text: `summary-page__cancel-active-permit__${permit.tariffId}--alert`, args},
			{text: PermitTranslations.summary_page__cancel_active_permit__alert, args}
		]);
	} else {
		message = translation([
			{text: `summary-page__cancel-permit__${permit.tariffId}--alert`, args},
			{text: PermitTranslations.summary_page__cancel_permit__alert, args}
		]);
	}

	if (!confirm(message)) {
		return;
	}

	const httpClient = getHttpClient();

	try {
		toggleLoadingDialog(true);
		await httpClient.permits.cancel(permit.id);
		await reloadPermits(ReloadEntities.Permits)
		navigate(PrivateRoutes.permitsList);
	} catch (error) {
		showErrorDialog(error);
	} finally {
		toggleLoadingDialog(false);
	}
}

export async function cancelPermits(permitIds: PermitId[], navigate: NavigateFunction): Promise<void> {
	const yes = confirm(translation(PermitTranslations.summary_page__cancel_permits__alert, {count: permitIds.length}));
	if (!yes) {
		return;
	}

	const httpClient = getHttpClient();

	try {
		toggleLoadingDialog(true);
		await httpClient.permits.bulkCancel(permitIds);
		await reloadPermits(ReloadEntities.Permits);
		navigate(PrivateRoutes.permitsList);
	} catch (error) {
		showErrorDialog(error);
	} finally {
		toggleLoadingDialog(false);
	}
}
